<template>
  <div class="user-page">
    <div class="wrapper user-page__wrapper" v-if="user">
      <UserPanel class="user-page__panel user-page__panel--desktop" />

      <router-view v-slot="{ Component }">
        <transition name="slide-from-right" mode="out-in">
          <component
            :is="Component"
            class="user-page__content"
            @changeAvatar="changeAvatar"
            @changeBio="changeBio"
            @deactivateAccount="deactivateAccount"
            @changePassword="changeUserPassword"
          ></component>
        </transition>
      </router-view>
    </div>
    <LoaderRing v-else />
  </div>
</template>

<script>
import { t } from "@/utils/translate";
import { onUnmounted, onMounted } from "vue";
import { setValidationStatusClass } from "@/utils/validation";

import UserPanel from "@/components/UserPanel";
import LoaderRing from "@/elements/LoaderRing";

import { useUserStore } from "@/store/userStore";
import { usePopupStore } from "@/store/popupStore";

import { storeToRefs } from "pinia";
import { customAxios } from "@/service/customAxios";
import { useRouter } from "vue-router";


export default {
  components: { UserPanel, LoaderRing },
  setup() {
    const userStore = useUserStore();
    const { user } = storeToRefs(userStore);
    const { setUser, clearUser } = userStore;
    const { showPopup } = usePopupStore();
    const router = useRouter();

    function changeModeByActualWidth() {
      if (window.innerWidth <= 992) {
        router.push({ path: "/user/panel" });
      } else {
        router.push({ path: "/user/account" });
      }
    }

    async function getUser() {
      try {
        const r = await customAxios.get(`person/i`);
       
        setUser(r.data);
      } catch (e) {
        console.log(e);
   
      }
    }

    async function changeAvatar() {
      try {
        getUser();
        showPopup(t("new.avatar.saved"), "success");
      } catch (e) {
        showPopup(t("something.went.wrong"), "error");
      }
    }
    async function changeUserPassword(password) {
      try {
        const options = {
          body: password.password,
        };
        await customAxios.post(`person/change_my_password`, options);
        showPopup('Пароль успешно изменен! Необходимо повторно войти в систему!', "success");
        clearUser();
        router.push({ path: "/auth/login" });
      } catch (e) {
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        } else {
          showPopup(t("something.went.wrong"), "error");
        }
      }
    }

    async function deactivateAccount() {
      try {
        await customAxios.post(`person/deactivate_my_profile`, '');
        showPopup('Учетная запись успешно деактивирована!', "success");
        clearUser();
        router.push({ path: "/" });
      } catch (e) {
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        } else {
          showPopup(t("something.went.wrong"), "error");
        }
      }
    }

    async function changeBio({ lastname, firstname, secname, notificationAgree, birthday }) {
      try {
        const options = {
          lastname: lastname,
          firstname: firstname,
          secname: secname,
          notificationAgree: notificationAgree,
          birthday: birthday
        };
        console.log("options:" + options)

        await customAxios.post(`person/change_my_profile`, options);

        showPopup(t("personal.data.is.updated"), "success");
        getUser();
      } catch (e) {
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        } else {
          showPopup(t("something.went.wrong"), "error");
        }
      }
    }

    onMounted(() => {
      getUser();
      window.addEventListener("resize", changeModeByActualWidth);
    });

    onUnmounted(() =>
      window.removeEventListener("resize", changeModeByActualWidth)
    );

    return {
      t,
      setValidationStatusClass,
      user,
      changeAvatar,
      changeBio,
      changeUserPassword,
      deactivateAccount
    };
  },
};
</script>

<style lang="scss">
.user-page {
  @include page;
  position: relative;

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__content {
    flex-grow: 1;
    background-color: #fff;
    border-radius: 16px;
  }

  &__panel {
    margin-right: 30px;
    align-self: flex-start;
  }

  &__wrapper {
    display: flex;
  }

  &__panel--mobile {
    display: none;
  }

  @media (max-width: 992px) {
    &__wrapper {
      display: block;
    }

    &__panel {
      margin-right: 0;
    }

    &__panel--desktop {
      display: none;
    }

    &__panel--mobile {
      display: block;
    }
  }
}
</style>
